import { styled } from "@grupoboticario/flora";


export const LogoStyle = styled("div", {
    color: "#FFF",
    "& svg": {
        maxWidth: "170px"
    }
})